import { useAppDispatch } from '~/redux/hooks';
import { setAllowAutoNavigation } from '~/redux/slices/stepper';

export const useResetSteps = () => {
  const dispatch = useAppDispatch();

  const restoreDataWithoutAutoNavigation = (callback: () => unknown) => {
    dispatch(setAllowAutoNavigation(false));
    callback();
    dispatch(setAllowAutoNavigation(true));
  };

  return { restoreDataWithoutAutoNavigation };
};
